import React, { useState } from 'react';

const LegalModals = () => {
  const [activeModal, setActiveModal] = useState(null);

  const closeModal = () => setActiveModal(null);

  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    },
    content: {
      background: '#fff',
      borderRadius: '16px',
      maxWidth: '800px',
      maxHeight: '80vh',
      overflow: 'auto',
      padding: '40px',
      position: 'relative',
      width: '100%',
    },
    closeBtn: {
      position: 'absolute',
      top: '15px',
      right: '20px',
      background: 'none',
      border: 'none',
      fontSize: '28px',
      cursor: 'pointer',
      color: '#333',
    },
    title: {
      color: '#255a5e',
      fontSize: '1.8rem',
      marginBottom: '20px',
      paddingRight: '40px',
    },
    section: {
      marginBottom: '25px',
    },
    sectionTitle: {
      color: '#27ae60',
      fontSize: '1.2rem',
      marginBottom: '10px',
    },
    text: {
      color: '#5d6d7e',
      fontSize: '1rem',
      lineHeight: '1.7',
      marginBottom: '10px',
    },
  };

  const TermosDeUso = () => (
    <div style={modalStyles.content}>
      <button style={modalStyles.closeBtn} onClick={closeModal}>&times;</button>
      <h2 style={modalStyles.title}>Termos de Uso</h2>
      
      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>1. Aceitação dos Termos</h3>
        <p style={modalStyles.text}>
          Ao acessar e utilizar o site MagriSim (www.magrisim.com.br), você concorda com estes Termos de Uso. 
          Se você não concordar com qualquer parte destes termos, não deve utilizar nosso site.
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>2. Identificação da Empresa</h3>
        <p style={modalStyles.text}>
          <strong>Razão Social:</strong> MMP Ltda<br/>
          <strong>CNPJ:</strong> 25.296.787/0001-01<br/>
          <strong>Endereço:</strong> Rua Rio Grande do Norte, 726 - Sala 703, Funcionários, Belo Horizonte - MG, CEP 30130-131, Brasil<br/>
          <strong>Telefone:</strong> (31) 3568-7051<br/>
          <strong>E-mail:</strong> contato@magrisim.com.br
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>3. Uso do Site</h3>
        <p style={modalStyles.text}>
          O conteúdo deste site é destinado apenas para fins informativos. As informações sobre produtos não devem 
          ser consideradas como aconselhamento médico. Consulte sempre um profissional de saúde antes de iniciar 
          qualquer programa de suplementação.
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>4. Propriedade Intelectual</h3>
        <p style={modalStyles.text}>
          Todo o conteúdo presente neste site, incluindo textos, imagens, logotipos e marcas registradas, 
          são de propriedade exclusiva da MMP Ltda ou de seus licenciadores. É proibida a reprodução, 
          distribuição ou modificação sem autorização prévia por escrito.
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>5. Limitação de Responsabilidade</h3>
        <p style={modalStyles.text}>
          Os resultados obtidos com o uso do MagriSim® podem variar de pessoa para pessoa. 
          A MMP Ltda não se responsabiliza por resultados individuais ou pelo uso inadequado do produto.
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>6. Alterações nos Termos</h3>
        <p style={modalStyles.text}>
          Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. 
          As alterações entrarão em vigor imediatamente após sua publicação no site.
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>7. Lei Aplicável</h3>
        <p style={modalStyles.text}>
          Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil.
          Qualquer disputa será submetida ao foro da comarca de Belo Horizonte - MG.
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>8. Política de Frete, Retorno e Reenvio de Mercadorias</h3>
        <p style={modalStyles.text}>
          A MAGAWAY subsidia parte dos custos logísticos de suas operações, assumindo parcela
          significativa do valor real do transporte para proporcionar melhores condições de compra
          aos seus clientes.
        </p>
        <p style={modalStyles.text}>
          O valor do frete apresentado no momento da compra poderá representar apenas parte do custo
          efetivamente suportado pela empresa para a realização da entrega.
        </p>
        <p style={modalStyles.text}>
          Nos casos em que a mercadoria retornar ao centro de distribuição por motivo atribuível ao
          consumidor, incluindo, mas não se limitando a:
        </p>
        <p style={modalStyles.text}>
          • endereço incorreto ou incompleto informado no pedido;<br/>
          • ausência de destinatário após as tentativas de entrega da transportadora;<br/>
          • recusa injustificada do recebimento da mercadoria;<br/>
          • não retirada da encomenda dentro do prazo estabelecido pela transportadora;<br/>
          • solicitação de novo envio após retorno da encomenda;
        </p>
        <p style={modalStyles.text}>
          o cliente será responsável pelos custos logísticos gerados, incluindo o valor integral do
          frete de envio e do eventual reenvio da mercadoria.
        </p>
        <p style={modalStyles.text}>
          Nos termos dos princípios da boa-fé objetiva previstos nos artigos 113 e 422 da Lei nº
          10.406/2002 (Código Civil), bem como da vedação ao enriquecimento sem causa prevista no
          artigo 884 do mesmo diploma legal, a empresa poderá descontar ou cobrar os custos
          efetivamente suportados com transporte, armazenagem e reexpedição da mercadoria quando o
          retorno ocorrer por fato imputável ao consumidor.
        </p>
        <p style={modalStyles.text}>
          Caso seja solicitado o reenvio do pedido após seu retorno ao centro de distribuição, o novo
          despacho somente ocorrerá mediante pagamento prévio do valor integral do frete correspondente.
        </p>
        <p style={modalStyles.text}>
          Ao concluir a compra, o consumidor declara estar ciente e de acordo com esta política,
          reconhecendo que os custos logísticos decorrentes de situações geradas por sua responsabilidade
          poderão ser cobrados ou descontados de eventuais valores a serem restituídos.
        </p>
      </div>

      <p style={{...modalStyles.text, marginTop: '30px', fontStyle: 'italic'}}>
        Última atualização: Janeiro de 2025
      </p>
    </div>
  );

  const PoliticaPrivacidade = () => (
    <div style={modalStyles.content}>
      <button style={modalStyles.closeBtn} onClick={closeModal}>&times;</button>
      <h2 style={modalStyles.title}>Política de Privacidade</h2>
      
      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>1. Introdução</h3>
        <p style={modalStyles.text}>
          A MMP Ltda ("nós", "nosso" ou "empresa") está comprometida em proteger sua privacidade. 
          Esta Política de Privacidade explica como coletamos, usamos e protegemos suas informações pessoais.
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>2. Dados Coletados</h3>
        <p style={modalStyles.text}>
          Podemos coletar os seguintes dados:<br/>
          • Nome completo<br/>
          • Endereço de e-mail<br/>
          • Número de telefone<br/>
          • Endereço de entrega<br/>
          • CPF (para emissão de nota fiscal)<br/>
          • Dados de navegação e cookies
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>3. Finalidade do Uso</h3>
        <p style={modalStyles.text}>
          Utilizamos seus dados para:<br/>
          • Processar pedidos e entregas<br/>
          • Enviar atualizações sobre seu pedido<br/>
          • Fornecer suporte ao cliente<br/>
          • Enviar comunicações de marketing (com seu consentimento)<br/>
          • Melhorar nossos produtos e serviços
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>4. Compartilhamento de Dados</h3>
        <p style={modalStyles.text}>
          Não vendemos suas informações pessoais. Podemos compartilhar dados apenas com:<br/>
          • Parceiros de logística para entrega dos produtos<br/>
          • Processadores de pagamento<br/>
          • Autoridades competentes quando exigido por lei
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>5. Segurança dos Dados</h3>
        <p style={modalStyles.text}>
          Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações 
          contra acesso não autorizado, alteração, divulgação ou destruição.
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>6. Seus Direitos (LGPD)</h3>
        <p style={modalStyles.text}>
          De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem direito a:<br/>
          • Acessar seus dados pessoais<br/>
          • Corrigir dados incompletos ou desatualizados<br/>
          • Solicitar a exclusão de seus dados<br/>
          • Revogar consentimentos concedidos<br/>
          • Solicitar portabilidade dos dados<br/><br/>
          Para exercer esses direitos, entre em contato: contato@magrisim.com.br
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>7. Cookies</h3>
        <p style={modalStyles.text}>
          Utilizamos cookies para melhorar sua experiência de navegação. Você pode configurar seu navegador 
          para recusar cookies, mas isso pode afetar algumas funcionalidades do site.
        </p>
      </div>

      <div style={modalStyles.section}>
        <h3 style={modalStyles.sectionTitle}>8. Contato</h3>
        <p style={modalStyles.text}>
          Para dúvidas sobre esta política, entre em contato:<br/>
          <strong>E-mail:</strong> contato@magrisim.com.br<br/>
          <strong>Telefone:</strong> (31) 3568-7051<br/>
          <strong>Endereço:</strong> Rua Rio Grande do Norte, 726 - Sala 703, Belo Horizonte - MG
        </p>
      </div>

      <p style={{...modalStyles.text, marginTop: '30px', fontStyle: 'italic'}}>
        Última atualização: Janeiro de 2025
      </p>
    </div>
  );

  return (
    <>
      {/* Botões invisíveis para trigger dos modals */}
      <button id="termos-modal" style={{ display: 'none' }} onClick={() => setActiveModal('termos')} />
      <button id="privacidade-modal" style={{ display: 'none' }} onClick={() => setActiveModal('privacidade')} />

      {/* Modal Overlay */}
      {activeModal && (
        <div style={modalStyles.overlay} onClick={closeModal}>
          <div onClick={(e) => e.stopPropagation()}>
            {activeModal === 'termos' && <TermosDeUso />}
            {activeModal === 'privacidade' && <PoliticaPrivacidade />}
          </div>
        </div>
      )}
    </>
  );
};

export default LegalModals;
